import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-fake-users',
  templateUrl: './add-fake-users.component.html',
  styleUrls: ['./add-fake-users.component.scss']
})
export class AddFakeUsersComponent implements OnInit {
formData: any = {
  name: '',
  email: '',
  mobile: '',
  country_id: '1',
  city_id: '1',
  password: '',
  password_confirmation: '',
  image: null
};

// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute, private translate: TranslateService
    ) { }
  
    ngOnInit(): void {
      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
  fetchBookForEdit(id: number): void {
  this.apisService.getFakeUserById(id).subscribe({
    next: (user) => {
      const data = user.data;
      this.formData.name = data.name;
      this.formData.email = data.email;
      this.formData.mobile = data.mobile;
      this.formData.country_id = data.country_id || '';
      this.formData.city_id = data.city_id || '';
      this.formData.password = ''; // Leave blank for security
      this.formData.password_confirmation = ''; // Leave blank
      this.imagePreview = data.image; // Show existing image
    },
    error: (err) => {
      console.error('Error fetching user:', err);
    },
  });
}


    cancel(): void {
      this.router.navigate(['/settings/countries']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    fetchUserForEdit(id: number): void {
  this.apisService.getFakeUserById(id).subscribe({
    next: (res) => {
      const user = res.data;
      this.formData.name = user.name;
      this.formData.email = user.email;
      this.formData.mobile = user.mobile;
      this.formData.country_id = user.country_id;
      this.formData.city_id = user.city_id;
      this.imagePreview = user.image;

      // Do NOT prefill passwords in edit mode for security reasons
      this.formData.password = '';
      this.formData.password_confirmation = '';
    },
    error: (err) => {
      console.error('Error fetching user:', err);
    }
  });
}



onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.image = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
}



submitForm(): void {
  const formDataToSend = new FormData();

  formDataToSend.append('name', this.formData.name);
  formDataToSend.append('email', this.formData.email);
  formDataToSend.append('mobile', this.formData.mobile);
formDataToSend.append('country_id', String(+this.formData.country_id));
formDataToSend.append('city_id', String(+this.formData.city_id));
  formDataToSend.append('password', this.formData.password);
  formDataToSend.append('password_confirmation', this.formData.password_confirmation);

if (this.formData.image) {
  formDataToSend.append('image', this.formData.image);
} else {
this.translate.get([
  'MENU.DASHBOARD.ERROR',
  'MENU.DASHBOARD.SELECT_IMAGE',
  'MENU.DASHBOARD.OK'
]).subscribe(trans => {
  Swal.fire({
    title: trans['MENU.DASHBOARD.ERROR'],
    text: trans['MENU.DASHBOARD.SELECT_IMAGE'],
    icon: 'error',
    confirmButtonText: trans['MENU.DASHBOARD.OK']
  });
});
    return;
}

  const id = this.route.snapshot.paramMap.get('id');

  this.apisService.addFakeUser(+id, formDataToSend).subscribe({
    next: (res) => {
      //  this.translate.get([
      //   'MENU.DASHBOARD.SUCCESS',
      //   'MENU.DASHBOARD.USER_SAVED'
      // ]).subscribe(trans => {
      //   Swal.fire(trans['MENU.DASHBOARD.SUCCESS'], trans['MENU.DASHBOARD.USER_SAVED'], 'success');
      // });
      // this.router.navigate(['/fake-user']);
      this.router.navigate(['/fake-user'], { queryParams: { success: 'true' } });

    },
    error: (err) => {
      console.error('Upload error:', err);
      this.translate.get([
        'MENU.DASHBOARD.ERROR',
        'MENU.DASHBOARD.FIX_ERRORS'
      ]).subscribe(trans => {
        Swal.fire(trans['MENU.DASHBOARD.ERROR'], trans['MENU.DASHBOARD.FIX_ERRORS'], 'error');
      });
    }
  });
}



}
